var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-checkbox-group",
    {
      class: { require: _vm.getRequire && _vm.isNull() },
      attrs: { size: "medium" },
      on: { change: _vm.change },
      model: {
        value: _vm.val,
        callback: function ($$v) {
          _vm.val = $$v
        },
        expression: "val",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c(
        "el-checkbox",
        {
          key: item[_vm.keyField],
          attrs: {
            label: item[_vm.keyField],
            size: "small",
            disabled: _vm.disabled,
            border: true,
          },
        },
        [_vm._v(" " + _vm._s(item[_vm.valueField]) + " ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }